import { Model } from '../common';
import * as api from '../api';

@Model('LiveStream')
export class LiveStream extends api.ApiLiveStream {
    static API = api.LiveStreamsApi;

    get seekable() {
        return false;
    }
    
    get type() {
        return 'LiveStream';
    }

    get name() {
        return this.title;
    }

    get summary() {
        return null;
    }

    get live() {
        return true;
    }
    
    get media_url() {
        if (!this.asset)
            return null;
        
        return this.asset.url;
    }
}